const profilesLayoutStyle = (theme) => ({
	top: {
		zIndex: "4",
	},
	search: {
		margin: "0",
		paddingTop: "7px",
		paddingBottom: "7px",
	},
	searchIcon: {
		width: "17px",
		zIndex: "4",
	},
	searchInput: {
		paddingTop: "2px",
	},
	card: {
		margin: "20px auto",
	},
});
export default profilesLayoutStyle;
